import { LokiUrl } from "./LokiUrl";
// This function handles special casing for Microsoft accounts to return df/msit loki domains.
// You should never call PPE Loki. That environment is not supported.
// We only use it for testing things internally that can't/shouldn't be deployed to DF.
export function getLokiDomainFromRegion(region) {
    /**
     * For MSIT and DF, region specific loki endpoint should be called i.e "https://<region>.loki.delve.office.com/".
     */
    if (region === "df") {
        return LokiUrl.Dogfood;
    }
    else if (region === "msit") {
        return LokiUrl.MSIT;
    }
    return undefined;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0TG9raURvbWFpbkZyb21SZWdpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0TG9raURvbWFpbkZyb21SZWdpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUVwQyw4RkFBOEY7QUFDOUYscUVBQXFFO0FBQ3JFLHVGQUF1RjtBQUN2RixNQUFNLFVBQVUsdUJBQXVCLENBQUMsTUFBYztJQUNwRDs7T0FFRztJQUNILElBQUksTUFBTSxLQUFLLElBQUksRUFBRTtRQUNuQixPQUFPLE9BQU8sQ0FBQyxPQUFPLENBQUM7S0FDeEI7U0FBTSxJQUFJLE1BQU0sS0FBSyxNQUFNLEVBQUU7UUFDNUIsT0FBTyxPQUFPLENBQUMsSUFBSSxDQUFDO0tBQ3JCO0lBRUQsT0FBTyxTQUFTLENBQUM7QUFDbkIsQ0FBQyJ9